import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import { useClubTheme } from '../../contexts/ClubThemeContext';

/**
 * Barre d'en-tête commune à StatsResults et MedidasResults.
 *
 * Layout :
 *   [ Compteur "X jugadores" ] [ slot filtres (children) ] ... [ Compare / Back ]
 *
 * Props :
 *   - count : nombre à afficher dans le badge
 *   - countLabel : libellé pluriel/singulier déjà calculé par le parent
 *   - compareMode : booléen (mode comparaison actif)
 *   - onOpenCompare : callback bouton "Comparer"
 *   - onExitCompare : callback bouton "Volver"
 *   - compareLabel / backLabel : libellés des boutons
 *   - children : zone optionnelle (ex. champ "minGames", légende, etc.)
 *   - dense : version compacte (mobile)
 */
const PlayerCompareBar = ({
  count,
  countLabel,
  compareMode,
  onOpenCompare,
  onExitCompare,
  compareLabel,
  backLabel,
  children,
  dense = false,
}) => {
  const { primaryColor } = useClubTheme();

  return (
    <Box
      sx={{
        mb: 2,
        p: dense ? 1 : 1.25,
        pl: dense ? 1.25 : 1.5,
        pr: dense ? 1.25 : 1.5,
        backgroundColor: '#fafafa',
        border: '1px solid #ececec',
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1.5,
      }}
    >
      {/* Boutons compare / back (à gauche) */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {!compareMode && (
          <Button
            variant="contained"
            color="primary"
            size={dense ? 'small' : 'medium'}
            onClick={onOpenCompare}
            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 1.5 }}
          >
            {compareLabel}
          </Button>
        )}
        {compareMode && (
          <Button
            variant="outlined"
            color="primary"
            size={dense ? 'small' : 'medium'}
            onClick={onExitCompare}
            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 1.5 }}
          >
            {backLabel}
          </Button>
        )}
      </Box>

      {/* Compteur */}
      <Chip
        icon={<GroupsIcon sx={{ color: 'white !important' }} />}
        label={
          <Typography
            component="span"
            sx={{ color: 'white', fontWeight: 700, fontSize: '0.78rem', letterSpacing: '0.3px' }}
          >
            {count} {countLabel}
          </Typography>
        }
        sx={{
          backgroundColor: primaryColor,
          height: 32,
          borderRadius: 1.5,
          paddingX: 0.5,
          '& .MuiChip-label': { paddingX: 1 },
        }}
      />

      {/* Slot filtres */}
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexGrow: 1, flexWrap: 'wrap' }}>
        {children}
      </Stack>
    </Box>
  );
};

export default PlayerCompareBar;
